import React from "react";
import { Stack } from "@chakra-ui/core";
import { useTranslation } from "~/i18n/hooks";
import { i18n } from "next-i18next";
import Head from "next/head";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetStaticProps } from "next";

const privacy = () => {
  const t = useTranslation();
  return (
    <Stack paddingX="4rem" marginTop="2rem">
      <Head>
        <title>{t("privacyPolicy.title")}</title>
        <meta content={t("privacyPolicy.description")} name="description" />
        <meta content={t("privacyPolicy.keywords")} name="keywords" />
        <link
          href={`${process.env.URL}/política-de-privacidad`}
          hrefLang="x-default"
          rel="alternate"
        />
        <link
          href={`${process.env.URL}/politica-de-privacidad`}
          hrefLang="es"
          rel="alternate"
        />
        <link
          href={`${process.env.URL}/pt/política-de-privacidade`}
          hrefLang="pt"
          rel="alternate"
        />
        <link
          href={`${process.env.URL}/en/privacy-policy`}
          hrefLang="en"
          rel="alternate"
        />
        <meta content={t("privacyPolicy.title")} property="og:title" />
        <meta
          content={t("privacyPolicy.description")}
          property="og:description"
        />
        <meta
          content={`${process.env.URL}/og-image-${i18n.language}.jpg`}
          property="og:image:url"
        />
        <meta content={t("privacyPolicy.title")} name="twitter:title" />
        <meta
          content={t("privacyPolicy.description")}
          name="twitter:description"
        />
        <meta
          content={`${process.env.URL}/og-image-${i18n.language}.jpg`}
          property="twitter:image"
        />
        <meta
          name="facebook-domain-verification"
          content="zkpe1pbv54w2vb37xfieodiezyc606"
        />
      </Head>
      <p className="c10" style={{ height: "4rem" }}>
        <span className="c11 header">Pol&iacute;ticas de Privacidad Pency</span>
      </p>
      <p className="c4" style={{ marginTop: "1rem" }}>
        {/* Se tiene que cambiar la fecha - PROD_CHANGE */}
        <span className="c2">Fecha de actualización </span>
        <span>29/07/2022</span>
      </p>
      <p className="c4">
        <span>
          TAP BILLETERA S.A., con domicilio en Maip&uacute; 1, Piso 22, Ciudad
          Aut&oacute;noma de Buenos Aires, Argentina (&ldquo;Pency&rdquo; o
          &ldquo;Nosotros&rdquo;) garantizamos la seguridad y la
          protecci&oacute;n de los datos personales (&ldquo;Datos
          Personales&rdquo;) de todos los clientes, socios, proveedores y
          usuarios (&quot;Usuarios&quot; o &quot;usted&quot;) del sitio web{" "}
        </span>
        <span>[URL PENCY] </span>
        <sup>
          <a href="#cmnt1" id="cmnt_ref1">
            [a]
          </a>
        </sup>
        <span className="c2">
          y cualquier otro sitio web, plataforma o aplicaci&oacute;n operada por
          Pency (&ldquo;Plataforma&rdquo;).
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          Esta Pol&iacute;tica de privacidad (&quot;Pol&iacute;tica de
          Privacidad&quot;) tiene como objetivo informarle c&oacute;mo usamos y
          divulgamos la informaci&oacute;n recopilada de sus visitas a nuestra
          Plataforma y de los mensajes que intercambiamos con usted
          (&quot;Comunicaciones&quot;).
        </span>
      </p>
      <p className="c4">
        <span>
          Esta Pol&iacute;tica de Privacidad s&oacute;lo aplica a la
          informaci&oacute;n recopilada a trav&eacute;s de la Plataforma y
          proporciona una descripci&oacute;n general de nuestras
          pr&aacute;cticas de privacidad y las elecciones que puede hacer,
          as&iacute; como los derechos que puede ejercer en relaci&oacute;n con
          los Datos Personales que procesamos. Si tiene alguna pregunta sobre el
          uso de sus Datos Personales, cont&aacute;ctenos por correo
          electr&oacute;nico a{" "}
        </span>
        <span className="c12">
          <a className="c0" href="mailto:centrodeayudapency@gmail.com">
            centrodeayudapency@gmail.com
          </a>
        </span>
        <span className="c2">.</span>
      </p>
      <p className="c4">
        <span className="c2">
          Esta Pol&iacute;tica de Privacidad no aplica a las aplicaciones,
          productos, servicios, sitios web o funciones de redes sociales de
          terceros que se pueden ofrecer o a los que se puede acceder a
          trav&eacute;s de la Plataforma. Acceder a estos enlaces har&aacute;
          que abandone la Plataforma y puede resultar en la recopilaci&oacute;n
          o el intercambio de informaci&oacute;n sobre usted por parte de
          terceros. No controlamos, respaldamos ni hacemos ninguna
          representaci&oacute;n sobre estos sitios de terceros o sus
          pr&aacute;cticas de privacidad, las cuales pueden diferir de las
          nuestras. Desde Pency recomendamos que revise la pol&iacute;tica de
          privacidad de cualquier sitio web con el que interact&uacute;e antes
          de permitir la recopilaci&oacute;n y uso de sus datos personales.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          Si nos env&iacute;a o comparte Datos Personales sobre otras personas,
          declara y garantiza que ha obtenido el consentimiento necesario para
          autorizar el uso de dicha informaci&oacute;n en los t&eacute;rminos de
          esta Pol&iacute;tica de Privacidad conforme lo exigen las Leyes de
          Protecci&oacute;n de Datos Personales.
        </span>
      </p>
      <p className="c4">
        <span className="c3">1. Definiciones</span>
      </p>
      <p className="c4">
        <span className="c2">
          A los efectos de esta Pol&iacute;tica de Privacidad se
          entender&aacute; como:
        </span>
      </p>
      <p className="c4">
        <span>(i) &ldquo;</span>
        <span className="c1">Datos Personales</span>
        <span className="c2">
          &rdquo;: cualquier informaci&oacute;n que, directa o indirectamente,
          identifique o pueda identificar a una persona natural o
          jur&iacute;dica, como nombre, DNI o CUIT, fecha de nacimiento,
          direcci&oacute;n IP, entre otros;
        </span>
      </p>
      <p className="c4">
        <span>(ii) &ldquo;</span>
        <span className="c1">Datos Personales Sensibles</span>
        <span className="c2">
          &rdquo;: cualquier informaci&oacute;n que revele el origen racial o
          &eacute;tnico, la convicci&oacute;n religiosa, la opini&oacute;n
          pol&iacute;tica, la afiliaci&oacute;n a un sindicato u
          organizaci&oacute;n de car&aacute;cter religioso, filos&oacute;fico o
          pol&iacute;tico, datos relativos a la salud o vida sexual, datos
          gen&eacute;ticos o biom&eacute;tricos en relaci&oacute;n con el
          titular del dato personal;
        </span>
      </p>
      <p className="c4">
        <span>(iii) &ldquo;</span>
        <span className="c1">Tratamiento de Datos Personales</span>
        <span className="c2">
          &rdquo;: cualquier operaci&oacute;n realizada en el &aacute;mbito de
          los Datos Personales, a trav&eacute;s de medios autom&aacute;ticos o
          no, tales como la recolecci&oacute;n, registro, organizaci&oacute;n,
          estructuraci&oacute;n, almacenamiento, adaptaci&oacute;n o
          alteraci&oacute;n, recuperaci&oacute;n, consulta, uso, la
          divulgaci&oacute;n por transmisi&oacute;n, difusi&oacute;n o, en su
          defecto, puesta a disposici&oacute;n, armonizaci&oacute;n o
          asociaci&oacute;n, restricci&oacute;n, eliminaci&oacute;n o
          destrucci&oacute;n. Tambi&eacute;n se considera Tratamiento de Datos
          Personales cualquier otra operaci&oacute;n prevista en los
          t&eacute;rminos de la legislaci&oacute;n aplicable;
        </span>
      </p>
      <p className="c4">
        <span>(iv) &ldquo;</span>
        <span className="c1">Leyes de Protecci&oacute;n de Datos</span>
        <span className="c2">
          &rdquo;: todas las disposiciones legales que regulan el Tratamiento de
          Datos Personales, incluyendo, pero sin limitarse a, la Ley de
          Protecci&oacute;n de Datos Personales Nro. 25.326, su decreto
          reglamentario Nro. 1558/2001 y las disposici&oacute;n y resoluciones
          emitidas de tanto en tanto por la autoridad de aplicaci&oacute;n.
        </span>
      </p>
      <p className="c4">
        <span className="c3">2. Datos Personales recopilados</span>
      </p>
      <p className="c4">
        <span className="c2">
          2.1 El p&uacute;blico en general podr&aacute; navegar por la
          Plataforma sin necesidad de registrarse ni proporcionar sus Datos
          Personales, excepto aquellos que son recolectados en forma
          autom&aacute;tica.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          Sin embargo, algunas de las caracter&iacute;sticas de la Plataforma
          pueden depender del registro y env&iacute;o de Datos Personales.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          2.2 Si usted se comunica con Pency, Pency puede recopilar:
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (i) Datos de contacto: nombre, apodo, tel&eacute;fono, ciudad, estado
          y direcci&oacute;n de correo electr&oacute;nico;
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (ii) Informaci&oacute;n que env&iacute;e: informaci&oacute;n que nos
          env&iacute;e a trav&eacute;s del formulario disponible (por ejemplo,
          quejas, sugerencias, cr&iacute;ticas, felicitaciones, etc.).
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          2.3 En la navegaci&oacute;n general por la Plataforma, Pency
          podr&aacute; recolectar:
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (i) Preferencias: informaci&oacute;n sobre sus preferencias e
          intereses con respecto a la Plataforma (cuando nos dice cu&aacute;les
          son o cuando podemos inferirlo de su comportamiento en la Plataforma)
          y c&oacute;mo prefiere recibir nuestras Comunicaciones;
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (ii) Datos de navegaci&oacute;n en la Plataforma: informaci&oacute;n
          sobre sus visitas y actividades en la Plataforma, incluido el
          contenido (y cualquier publicidad) que ve y con el que
          interact&uacute;a, informaci&oacute;n sobre el navegador y el
          dispositivo que est&aacute; utilizando, su direcci&oacute;n IP, su
          ubicaci&oacute;n o la direcci&oacute;n del sitio web desde el que
          accede. Parte de la informaci&oacute;n se recopila utilizando nuestras
          herramientas de recopilaci&oacute;n autom&aacute;tica de datos, que
          incluyen cookies, balizas web y enlaces web integrados. Para obtener
          m&aacute;s informaci&oacute;n, lea c&oacute;mo usamos las herramientas
          de recopilaci&oacute;n autom&aacute;tica de datos en el punto 6;
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (iii) Otra informaci&oacute;n que podamos recopilar: otra
          informaci&oacute;n que no revele espec&iacute;ficamente su identidad o
          que no est&eacute; directamente relacionada con una persona, como la
          informaci&oacute;n del navegador y del dispositivo; datos de uso de la
          plataforma; e informaci&oacute;n recopilada a trav&eacute;s de
          cookies, etiquetas de p&iacute;xeles y otras tecnolog&iacute;as.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          2.4 En situaciones espec&iacute;ficas (por ejemplo, encuestas que
          realizamos para conocer el perfil de nuestros clientes), podemos
          tratar Datos Sensibles de nuestros clientes directos y/o indirectos
          (como en el caso de los clientes de nuestros clientes). Cuando esto
          ocurra, dicho tratamiento se dar&aacute; de conformidad con los
          requisitos establecidos en las Leyes de Protecci&oacute;n de Datos
          Personales, en particular al obtener el consentimiento de nuestros
          clientes y/o consumidores, cuando sea necesario.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          2.5. No est&aacute; obligado a compartir con nosotros los Datos
          Personales que solicitamos; sin embargo, si elige no compartirlos, en
          algunos casos es posible que no podamos brindarle acceso completo a la
          Plataforma o a algunas funciones especializadas, o que no podamos para
          responder eficazmente a cualquier consulta que pueda tener. En los
          casos en que sea necesario su consentimiento para realizar una
          determinada actividad, le informaremos de las consecuencias de no
          facilitarlo.
        </span>
      </p>
      <p className="c4 c7">
        <span className="c2"></span>
      </p>
      <p className="c4">
        <span className="c2">
          3. Objetivos en la recopilaci&oacute;n de Datos Personales
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          3.1 Recopilamos y usamos Datos Personales para administrar su
          relaci&oacute;n con Pency y brindarle un mejor servicio cuando utiliza
          la Plataforma, personalizando y mejorando su experiencia. Ejemplos de
          c&oacute;mo usamos los Datos Personales incluyen:
        </span>
      </p>
      <ul className="c6 lst-kix_list_1-0 start">
        <li className="c4 c5 li-bullet-0">
          <span className="c2">
            Para que Usted pueda registrarse, acceder, utilizar y navegar la
            Plataforma;
          </span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">Para verificar y validar su identidad;</span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">
            Para prestar nuestros servicios a trav&eacute;s de la Plataforma,
            procesar sus solicitudes y transacciones, elaborar y mantener un
            registro de las operaciones que realice en la Plataforma y darles
            seguimiento;
          </span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">
            Para responder a los requerimientos y consultas que realice a
            trav&eacute;s de la Plataforma, ya sea acerca de los productos y
            servicios de Pency y/u otros;
          </span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">
            Para mantener contacto con los Usuarios, atender los comentarios,
            quejas y sugerencias;
          </span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">
            Para cobrar y facturar las cantidades previstas en los servicios
            contratados por usted;
          </span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">
            Para confirmar o corregir la informaci&oacute;n que tenemos sobre
            usted;
          </span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">
            Para enviarle informaci&oacute;n que creemos ser&aacute; de su
            inter&eacute;s, a trav&eacute;s de comunicaciones de marketing;
          </span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">
            Para personalizar su experiencia de uso de la Plataforma;
          </span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">
            Para comunicarnos con usted a un n&uacute;mero de tel&eacute;fono
            y/o direcci&oacute;n de correo electr&oacute;nico proporcionados,
            con fines de soporte, resoluci&oacute;n de problemas y, cuando sea
            necesario, para fines comerciales razonables, como enviarle
            informaci&oacute;n promocional de productos o servicios de Pency o
            de nuestros socios;
          </span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">
            Para mejorar los servicios y las funcionalidades de la Plataforma
          </span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">
            Para cumplir con los requisitos de un proceso legal;
          </span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">
            Para cumplir con una decisi&oacute;n judicial o de autoridad
            administrativa competente, incluidos los tribunales y las
            autoridades fuera del pa&iacute;s de residencia de los Usuarios;
          </span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">
            Para hacer cumplir nuestros T&eacute;rminos y condiciones de uso;
          </span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">Para proteger nuestras operaciones;</span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">
            Para proteger los derechos, la privacidad, la seguridad de Pency, la
            suya o la de otros Usuarios o terceros;
          </span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">Para detectar y prevenir el fraude;</span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">
            Para permitirnos utilizar los recursos disponibles o limitar los
            da&ntilde;os que podamos sufrir;
          </span>
        </li>
        <li className="c4 c5 li-bullet-0">
          <span className="c2">
            Para realizar encuestas de calidad, para conocer c&oacute;mo es su
            relaci&oacute;n con nosotros y los servicios que le brindamos (por
            ejemplo, la jornada empresarial y las estrategias aplicadas en su
            tienda virtual en un a&ntilde;o determinado);
          </span>
        </li>
      </ul>
      <p className="c4">
        <span className="c2">
          4. Terceros con quienes compartimos sus Datos Personales
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          4.1 Pency puede compartir sus Datos Personales:
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (i) Con la(s) empresa(s) asociada(s) que seleccione o elija para
          enviar sus datos, consultas, preguntas, etc., as&iacute; como
          tambi&eacute;n con proveedores de servicios o socios de Pency para
          administrar o respaldar ciertos aspectos de nuestras operaciones
          comerciales en nuestro nombre, incluyendo proveedores de servidores
          para aprobaci&oacute;n y producci&oacute;n; proveedores de alojamiento
          y almacenamiento de datos; proveedores de validaci&oacute;n de
          identidad, gesti&oacute;n de fraudes, atenci&oacute;n al cliente,
          ventas en nuestro nombre, cumplimiento de pedidos,
          personalizaci&oacute;n de contenido, actividades de publicidad y
          marketing (incluida la publicidad digital y personalizada) y servicios
          de TI; empresas procesadoras de pagos; proveedores de sistemas
          inform&aacute;ticos; proveedores de servicios en la nube; proveedores
          de servicios tecnol&oacute;gicos en general, call centers o centros de
          atenci&oacute;n al cliente; agencias de publicidad o marketing;
          agencias de an&aacute;lisis de datos; consultores de seguros, legales
          y/o financieros; otros agentes y representantes, por ejemplo:
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (ii) Con terceros, con el fin de ayudarnos a administrar la
          Plataforma;
        </span>
      </p>
      <p className="c4" id="h.gjdgxs">
        <span className="c2">
          (iii) Con entidades financieras y cualquier otra empresa que pudiera
          ser necesaria para prestar los Servicios ofrecidos mediante la
          Plataforma.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          Los Datos Personales de los Usuarios no ser&aacute;n utilizados por
          los terceros proveedores de servicios para ning&uacute;n otro
          prop&oacute;sito que aquel para el cual Pency se los transfiri&oacute;
          y siempre los procesar&aacute;n siguiendo las instrucciones de Pency.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (iv) Ante un proceso de auditor&iacute;a en caso de una potencial
          reorganizaci&oacute;n, fusi&oacute;n, venta, asociaci&oacute;n en
          participaci&oacute;n, cesi&oacute;n, transferencia de la totalidad o
          parte de nuestra empresa, activos o capital, con los potenciales
          adquirentes y/o sus asesores, siempre bajo obligaci&oacute;n de
          confidencialidad.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (v) Con terceros adquirentes de cualquier reorganizaci&oacute;n,
          fusi&oacute;n, venta, asociaci&oacute;n en participaci&oacute;n,
          cesi&oacute;n, transferencia o transferencia de la totalidad o parte
          de nuestra empresa, activos o capital (incluidos los relacionados con
          procesos concursales o similares), quienes pasar&aacute;n a ser los
          responsables del procesamiento de los Datos Personales.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (vi) Con entidades pertenecientes al mismo grupo corporativo de o
          empresas asociadas a Pency en todo el mundo de acuerdo con esta
          Pol&iacute;tica de Privacidad.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          5. Transferencias internacionales de Datos Personales
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          5.1 Cuando sea necesario transferir Datos Personales, Pency
          adoptar&aacute; las salvaguardas necesarias para que sus Datos
          Personales tengan un nivel de protecci&oacute;n equivalente al que
          hemos adoptado y, cuando sea necesario, utilizaremos el mecanismo de
          transferencia internacional de datos requerido por las leyes de
          protecci&oacute;n de datos.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          5.2 Usted expresamente entiende y acepta que sus Datos Personales
          pueden ser compartidos, cedidos o transferidos fuera de su pa&iacute;s
          de residencia para su procesamiento para las finalidades descriptas en
          la presente Pol&iacute;tica de Privacidad incluso cuando los
          destinatarios est&eacute;n ubicados en otros pa&iacute;ses que no
          garanticen los mismos niveles de protecci&oacute;n que las Leyes de
          Protecci&oacute;n de Datos Personales.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          6. Forma de recolecci&oacute;n autom&aacute;tica de Datos Personales
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          6.1 Cuando visita la Plataforma, esta puede almacenar o recuperar
          informaci&oacute;n en su navegador, principalmente mediante el uso de
          cookies, que son archivos de texto que contienen peque&ntilde;as
          cantidades de informaci&oacute;n.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          6.2 Esta informaci&oacute;n puede ser sobre usted, sus preferencias o
          su dispositivo y se usa principalmente para hacer que la Plataforma
          funcione como usted espera. La informaci&oacute;n generalmente no lo
          identifica directamente, pero puede proporcionar una experiencia web
          m&aacute;s personalizada.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          6.3 De acuerdo con esta Pol&iacute;tica de Privacidad de Pency,
          nosotros y nuestros proveedores de servicios externos podemos
          recopilar sus Datos personales de varias maneras, que incluyen, entre
          otras:
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (i) A trav&eacute;s del navegador o dispositivo: la mayor&iacute;a de
          los navegadores o dispositivos de acceso a Internet recopilan cierta
          informaci&oacute;n, como el tipo de computadora, la resoluci&oacute;n
          de pantalla, el nombre y la versi&oacute;n del sistema operativo, el
          modelo y el fabricante del dispositivo, el idioma, el tipo y la
          versi&oacute;n del navegador de Internet que est&eacute; utilizando.
          Podemos utilizar esta informaci&oacute;n para garantizar que la
          Plataforma funcione correctamente.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (ii) Uso de cookies: La informaci&oacute;n sobre su uso de la
          Plataforma puede ser recopilada por terceros a trav&eacute;s de
          cookies. Las cookies son informaci&oacute;n almacenada directamente en
          la computadora que est&aacute; utilizando. Las cookies permiten
          recopilar informaci&oacute;n como el tipo de navegador, el tiempo que
          se pasa en la Plataforma, las p&aacute;ginas visitadas, las
          preferencias de idioma y otros datos de tr&aacute;fico
          an&oacute;nimos. Nosotros y nuestros proveedores de servicios usamos
          informaci&oacute;n para proteger la seguridad, facilitar la
          navegaci&oacute;n, mostrar informaci&oacute;n de manera m&aacute;s
          eficiente y personalizar su experiencia al usar la Plataforma,
          as&iacute; como para el seguimiento en l&iacute;nea. Tambi&eacute;n
          recopilamos informaci&oacute;n estad&iacute;stica sobre su uso de la
          Plataforma para mejorar continuamente nuestro dise&ntilde;o y
          funcionalidad, para comprender c&oacute;mo se usa la Plataforma y para
          ayudarlo a resolver problemas relacionados con la Plataforma.
        </span>
      </p>
      <p className="c4">
        <span className="c2">7. Duraci&oacute;n del tratamiento</span>
      </p>
      <p className="c4">
        <span className="c2">
          7.1 Los Datos Personales procesados por Pency se almacenar&aacute;n
          durante el tiempo que sea necesario para cumplir con los fines para
          los que fueron recopilados.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          7.2 Sin embargo, los Datos Personales pueden conservarse por un
          per&iacute;odo m&aacute;s largo, para cumplir con una
          obligaci&oacute;n legal o reglamentaria, para cumplir con una orden de
          autoridad competente, o bien para el ejercicio del derecho de defensa
          de Pency en procedimientos judiciales o administrativos por todo el
          plazo de prescripci&oacute;n de los mismos.
        </span>
      </p>
      <p className="c4">
        <span className="c2">8. Derechos del usuario</span>
      </p>
      <p className="c4">
        <span className="c2">
          8.1. Usted puede, en cualquier momento, ejercer los derechos que las
          Leyes de Protecci&oacute;n de Datos Personales le garantizan como
          titular de datos, entre otros, Usted puede solicitar a Pency:
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (i) confirmaci&oacute;n de que sus Datos Personales est&aacute;n
          siendo procesados;
        </span>
      </p>
      <p className="c4">
        <span className="c2">(ii) acceso a sus Datos Personales;</span>
      </p>
      <p className="c4">
        <span className="c2">
          (iii) correcci&oacute;n de datos incompletos, inexactos o
          desactualizados;
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (iv) anonimizaci&oacute;n, bloqueo o eliminaci&oacute;n (en caso de
          corresponder) de datos innecesarios, excesivos o tratados en
          violaci&oacute;n de la ley;
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (v) la portabilidad de los Datos Personales a otro proveedor de
          servicios, siempre que ello no afecte nuestros secretos industriales y
          comerciales;
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (vi) la eliminaci&oacute;n de los Datos Personales procesados con su
          consentimiento, en la medida permitida por la ley;
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (vii) informaci&oacute;n sobre las entidades con las que se han
          compartido sus Datos Personales;
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          (viii) informaci&oacute;n sobre la posibilidad de no prestar el
          consentimiento y las consecuencias de no prestar el consentimiento; y
        </span>
      </p>
      <p className="c4">
        <span className="c2">(ix) revocaci&oacute;n del consentimiento.</span>
      </p>
      <p className="c4">
        <span className="c2">
          8.2 Sus solicitudes ser&aacute;n tratadas con especial cuidado para
          que podamos garantizar la efectividad de sus derechos. Como resultado,
          podemos pedirle que proporcione una prueba de su identidad para
          garantizar que los Datos personales solo se compartan con el titular.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          8.3 Debe tener en cuenta que, en determinados casos (por ejemplo,
          debido a requisitos legales o limitaciones t&eacute;cnicas), es
          posible que su pedido no se satisfaga de inmediato y/o que Pency no
          pueda cumplirlo debido a la necesidad de cumplimiento de obligaciones
          legales.
        </span>
      </p>
      <p className="c4">
        <span className="c2">9. Seguridad de los Datos Personales</span>
      </p>
      <p className="c4">
        <span className="c2">
          9.1 Pency procura adoptar las medidas t&eacute;cnicas y organizativas
          previstas por las Leyes de Protecci&oacute;n de Datos y que sean
          adecuadas para la protecci&oacute;n de los Datos Personales.
          Desafortunadamente, no podemos garantizar que ning&uacute;n sistema de
          transmisi&oacute;n o almacenamiento de datos sea 100% seguro. Si tiene
          motivos para creer que su interacci&oacute;n con nosotros ya no es
          segura (por ejemplo, si cree que la seguridad de cualquiera de sus
          cuentas se ha visto comprometida), notif&iacute;quenos de inmediato.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          10. Enlaces de hipertexto a otros sitios web y redes sociales
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          10.1 La Plataforma puede contener enlaces de hipertexto que lo
          redirigir&aacute;n a los sitios web de las redes, anunciantes,
          proveedores, etc. de nuestros socios. Si hace clic en uno de estos
          enlaces a cualquiera de estos sitios, le recordamos que cada sitio
          tiene sus propias pr&aacute;cticas de privacidad y que no somos
          responsables de esas pol&iacute;ticas. Consulte esas pol&iacute;ticas
          antes de enviar Datos Personales a estos sitios.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          10.2 No somos responsables de las pol&iacute;ticas y pr&aacute;cticas
          de recopilaci&oacute;n, uso y divulgaci&oacute;n (incluidas las
          pr&aacute;cticas de protecci&oacute;n de datos) de otras
          organizaciones, como Facebook, Apple, Google, Microsoft o cualquier
          otro desarrollador de software o proveedor de aplicaciones,
          plataformas de redes sociales, operadores sistema, proveedor de
          servicios inal&aacute;mbricos de Internet o fabricante del
          dispositivo, incluidos los datos personales que divulgue a otras
          organizaciones a trav&eacute;s de las aplicaciones, en relaci&oacute;n
          con dichas aplicaciones o publicados en nuestras p&aacute;ginas de
          redes sociales. Le recomendamos que se informe sobre la
          pol&iacute;tica de privacidad de cada sitio web que visite o de cada
          proveedor de servicios que utilice.
        </span>
      </p>
      <p className="c4">
        <span className="c2">11. Uso de la Plataforma por Menores</span>
      </p>
      <p className="c4">
        <span className="c2">
          11.1 La plataforma no est&aacute; destinada a personas menores de 18
          (dieciocho) a&ntilde;os y solicitamos que dichas personas no nos
          proporcionen ning&uacute;n dato personal.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          12. Actualizaciones a esta Pol&iacute;tica de Privacidad
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          12.1 Si modificamos nuestra Pol&iacute;tica de Privacidad,
          publicaremos el nuevo texto en la Plataforma, con la fecha de
          revisi&oacute;n actualizada. Podemos cambiar esta Pol&iacute;tica de
          Privacidad en cualquier momento. Si hay un cambio sustancial en los
          t&eacute;rminos de esta Pol&iacute;tica de Privacidad, podemos
          informarle a trav&eacute;s de la informaci&oacute;n de contacto que
          tenemos en nuestra base de datos o mediante una notificaci&oacute;n en
          nuestra Plataforma y recabaremos su consentimiento en caso de ser
          necesario bajo la Ley de Protecci&oacute;n de Datos Personales.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          12.2 Le recordamos que nos comprometemos a no procesar sus Datos
          Personales de manera incompatible con los fines descritos
          anteriormente, a menos que la ley o una orden judicial exijan lo
          contrario.
        </span>
      </p>
      <p className="c4">
        <span className="c2">
          13. Responsable del Tratamiento de Datos Personales
        </span>
      </p>
      <p className="c4">
        <span>
          13.1 TAP BILLETERA S.A., con domicilio en Maip&uacute; 1, Piso 22,
          Ciudad Aut&oacute;noma de Buenos Aires, Argentina, es la responsable
          del Tratamiento de sus Datos Personales en la Plataforma. Si pretende
          ejercer alguno de los derechos previstos en esta Pol&iacute;tica de
          Privacidad y/o en las Leyes de Protecci&oacute;n de Datos, o resolver
          cualquier duda relacionada con el Tratamiento de sus Datos Personales,
          p&oacute;ngase en contacto con nosotros a trav&eacute;s del correo
          electr&oacute;nico{" "}
        </span>
        <span className="c12">
          <a className="c0" href="mailto:centrodeayudapency@gmail.com">
            centrodeayudapency@gmail.com
          </a>
        </span>
        <span className="c2">.</span>
      </p>
      <div className="c9">
        <p className="c13">
          <a href="#cmnt_ref1" id="cmnt1">
            [a]
          </a>
          <span className="c8">Rellenar con link de la pagina web</span>
        </p>
      </div>
    </Stack>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  // Return stores so we can build a directory
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
};

export default privacy;
